var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-bottom-sheet",
        {
          model: {
            value: _vm.contact,
            callback: function($$v) {
              _vm.contact = $$v
            },
            expression: "contact"
          }
        },
        [
          _c(
            "v-sheet",
            { staticClass: "text-center pt-2", attrs: { height: "105px" } },
            [
              _c(
                "v-row",
                { staticClass: "px-3" },
                [
                  _c("v-col", { staticClass: "compact" }, [
                    _c(
                      "a",
                      {
                        staticClass: "contact-link",
                        attrs: {
                          target: "_blank",
                          href: "mailto:contact@i2e1.com"
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            height: "36px",
                            src: require("img/icons/email.svg")
                          }
                        }),
                        _c("br"),
                        _vm._v("Email ")
                      ]
                    )
                  ]),
                  _c("v-col", [
                    _c(
                      "a",
                      {
                        staticClass: "contact-link",
                        attrs: {
                          target: "_blank",
                          href:
                            "https://wa.me/918880322222?text=I'm%20facing%20issues%20with%20my%20hotspot"
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            height: "36px",
                            src: require("img/icons/whatsapp.png")
                          }
                        }),
                        _c("br"),
                        _vm._v("Whatsapp ")
                      ]
                    )
                  ]),
                  _c("v-col", { staticClass: "compact" }, [
                    _c(
                      "a",
                      {
                        staticClass: "contact-link",
                        attrs: { target: "_blank", href: "tel:+918880322222" }
                      },
                      [
                        _c("img", {
                          attrs: {
                            height: "36px",
                            src: require("img/icons/call.svg")
                          }
                        }),
                        _c("br"),
                        _vm._v("Call ")
                      ]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v("Troubleshoot")
          ]),
          _c("v-card-text", [
            _vm._v(" Your device seems "),
            _c("b", [_vm._v("Not Working")]),
            _vm._v(". Follow below steps to make it "),
            _c("b", [_vm._v("Work:")]),
            _c("ol", [
              _c("li", [
                _vm._v(" Check if the "),
                _c("u", [_vm._v("lights")]),
                _vm._v(" for "),
                _c("b", [_vm._v("Power")]),
                _vm._v(", "),
                _c("b", [_vm._v("Internet")]),
                _vm._v(", and "),
                _c("b", [_vm._v("Wi-Fi")]),
                _vm._v(" are ON for both devices ")
              ]),
              _c("li", [_vm._v("Check if your main internet is working")]),
              _c("li", [
                _vm._v(" Check if the "),
                _c("u", [_vm._v("LAN cable")]),
                _vm._v(" is connected to the WAN port of the "),
                _c("b", [_vm._v("WIOM device")]),
                _vm._v(" and the LAN port of your "),
                _c("b", [_vm._v("internet device")])
              ])
            ]),
            _c("br"),
            _vm._v(
              "To confirm if your Guest Wi-Fi is working: Try to connect to the WIOM Wi-FI "
            ),
            _c("br"),
            _c("br"),
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "12px",
                  "text-transform": "italics"
                }
              },
              [
                _vm._v(" If it is still not working, email us at "),
                _c("u", [
                  _c("a", { attrs: { href: "mailto:contact@i2e1.com" } }, [
                    _vm._v("contact@i2e1.com")
                  ])
                ]),
                _vm._v(" or call us at "),
                _c("u", [
                  _c("a", { attrs: { href: "tel:+918880322222" } }, [
                    _vm._v("+91-8880322222")
                  ])
                ])
              ]
            )
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticStyle: { padding: "5px 20px 5px 20px" },
                  attrs: { large: "", color: "#333", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("cancel")
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  staticStyle: {
                    "font-weight": "400",
                    margin: "0px 10px 10px 25px",
                    color: "#fff",
                    "border-radius": "3px !important",
                    padding: "5px 20px 5px 20px"
                  },
                  attrs: { large: "", id: "submit", depressed: "" },
                  on: {
                    click: function($event) {
                      return _vm.showContact()
                    }
                  }
                },
                [_vm._v("Contact Us")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }